import request from "@/utils/request";
import { ElMessage } from "element-plus";

export interface UploadResponse {
  code: number;
  msg: string | null;
  data: string;
}

export const validateImage = (file: File) => {
  // const isImage = /^image\/(jpeg|png|gif)$/.test(file.type)
  const isLt5M = file.size / 1024 / 1024 < 5;

  // if (!isImage) {
  //   ElMessage.error('只能上传 JPG/PNG/GIF 格式图片!')
  //   return false
  // }
  if (!isLt5M) {
    ElMessage.error("图片大小不能超过 5MB!");
    return false;
  }
  return true;
};

export const beforeImageUpload = (file: File) => {
  return validateImage(file);
};

export const uploadImage = async (file: File): Promise<string | null> => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await request<UploadResponse>({
      url: "/common/image",
      method: "POST",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Origin: window.location.origin, // 显式声明源
      },
    });

    // 确保我们访问的是 response.data
    const result = response; // UploadResponse 类型

    // 修改判断逻辑
    if (result.code === 1) {
      // 简化条件判断
      const imageUrl = result.data;
      const fullImageUrl = imageUrl.startsWith("http")
        ? imageUrl
        : `http://8.138.108.78/${imageUrl.replace("8.138.108.78", "")}`;

      console.log("处理后的图片URL:", fullImageUrl);
      return fullImageUrl;
    }

    ElMessage.error(result?.msg || "图片上传失败");
    return null;
  } catch (error) {
    console.error("图片上传失败:", error);
    ElMessage.error("图片上传失败，请重试");
    return null;
  }
};
export const uploadFile = async (file: File): Promise<string | null> => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await request<UploadResponse>({
      url: "/admin/file",
      method: "POST",
      data: formData,
      // headers: {
      //   'Content-Type': 'multipart/form-data'
      // }
    });

    if (response.code === 1) {
      return response.data;
    }

    ElMessage.error(response?.msg || "文件上传失败");
    return null;
  } catch (error) {
    console.error("文件上传失败:", error);
    ElMessage.error("文件上传失败，请重试");
    return null;
  }
};
